import React from "react";
import { PageHero, Section } from "./_shared";
import { useMitmcvc } from "./MitmcvcLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function ExecutiveBody() {
  const data = useMitmcvc();
  const list = data?.executive_body || [];
  return (
    <div data-testid="mitmcvc-executive-body">
      <PageHero
        eyebrow="आमच्याविषयी"
        title="कार्यकारी मंडळ"
        sub="ग्रामोद्योगिक शिक्षण मंडळाचे कार्यकारी मंडळ — संपूर्ण संस्थेस दिशा आणि व्यवस्थापन देणारे सदस्य."
      />
      <Section>
        <BodyMembersTable members={list} theme="amber" testidPrefix="mitmcvc-eb" />
      </Section>
    </div>
  );
}
